const wishlist = {
    namespaced: true,
    state: {
        list: []
    },
    mutations: {
        addItem(state, product) {
            state.list.push(product);
        },
        removeItem(state, product) {
     
              let index = state.list.findIndex(p => p.stockcode == product);
              state.list.splice(index, 1);

        },
        clear(state, product) {
            for (var i = state.list.length - 1; i >= 0; i--) {
                if (state.list[i] === product) {
                    state.list.splice(i, 1);
                }
            }
        }
    },
    actions: {},
    getters: {
        count: state => {
            return state.list.length;
        }
    }
};

export default wishlist;
